// Konfiguracja tabeli ostatnich zamówień dla dashboardu handlowca

import { IWiseTableColumn, IWiseTableParameter, IWiseTableAction } from 'components/wise';
import { ILoadDataParam } from 'plugins/api/types';

/**
 * Funkcja tworząca konfigurację parametrów (opcji nad tabelą)
 * @param t - funkcja tłumaczeń
 */
export const getTraderDashboardLastOrdersTableParameters = (
  t: (key: string) => string
): IWiseTableParameter[] => {
  return [
    {
      type: 'search',
      label: t('Szukaj zamówienia'),
      field_symbol: 'search_keyword',
      default_value: ''
    }
  ];
};

/**
 * Funkcja tworząca konfigurację kolumn
 * @param t - funkcja tłumaczeń
 */
export const getTraderDashboardLastOrdersTableColumns = (
  t: (key: string) => string
): IWiseTableColumn[] => {
  return [
    {
      type: 'avatar',
      label: t('Klient'),
      field_symbol: 'client_name',
      align: 'left',
      tooltip: null,
      size: 200
    },
    {
      type: 'date',
      label: t('Data'),
      field_symbol: 'sys_insert_date',
      align: 'center',
      tooltip: null,
      size: 150
    },
    {
      type: 'text',
      label: t('Wartość netto'),
      field_symbol: 'value_net_formatted',
      align: 'right',
      tooltip: null,
      size: 120
    },
    {
      type: 'text',
      label: 'ID',
      field_symbol: 'id',
      align: 'center',
      tooltip: null,
      size: 100
    }
  ];
};

/**
 * Funkcja tworząca konfigurację akcji
 * @param t - funkcja tłumaczeń
 */
export const getTraderDashboardLastOrdersTableActions = (
  t: (key: string) => string
): IWiseTableAction[] => {
  return [
    {
      symbol: null,
      type: 'HEADER',
      label: t('Otwórz listę zamówień'),
      style: null,
      method: 'Redirect',
      method_params: {
        command_url: '',
        page_url: '/trader/sales',
        params_list: null
      },
      refresh_data_mode: 'NONE',
    }
  ];
};

/**
 * Parametry do pobierania danych
 * Mockowany endpoint - będzie zwracał dane z JSON
 */
export const traderDashboardLastOrdersTableLoadDataParams: ILoadDataParam = {
  get_url: '/sales-crm/orders?no_pagination=1',
  params_list: null
};
